
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-business-number",
      function () {
        return require("private-next-pages/whatsapp-business-number.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-business-number"])
      });
    }
  